import * as z from 'zod'

export const verifyAccountSchema = z.object({
  email: z.email(),
  otp_code: z.string(),
})

export type VerifyAccountDto = z.infer<typeof verifyAccountSchema>
